import Image from 'next/image';
import Link from 'next/link';

import type { ArticleCarouselItem } from '@/components/article/article-carousel-item';

const DEFAULT_CARD_IMAGE =
  'https://images.opendoor.com/source/s3/imgdrop-production/4b831192b06849a589afcef62a25757d.jpg?preset=square-1024';

export function ArticleCard({
  article,
  tabIndex,
  titleElement: TitleElement = 'h2',
  priority = false,
  fetchPriority,
}: {
  article: ArticleCarouselItem;
  tabIndex?: number;
  titleElement?: 'h2' | 'h3';
  priority?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-3xl bg-canvas transition hover:shadow-[0_8px_24px_rgba(0,0,0,0.06)]">
      <Link
        href={`/articles/${article.slug}`}
        prefetch={false}
        tabIndex={tabIndex}
        className="flex h-full flex-col"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-accent">
          <Image
            src={article.imageSrc ?? DEFAULT_CARD_IMAGE}
            alt={article.imageAlt ?? ''}
            fill
            sizes="(min-width: 1280px) 20vw, (min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw"
            quality={60}
            priority={priority}
            fetchPriority={fetchPriority}
            className="object-cover transition-transform duration-300 group-hover:scale-[1.02]"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          {article.dateLabel ? (
            <p className="font-medium text-ink-muted text-body-sm">{article.dateLabel}</p>
          ) : null}
          <TitleElement className="mt-3 font-medium leading-tight tracking-tight text-ink text-body-lg group-hover:text-accent">
            {article.title}
          </TitleElement>
        </div>
      </Link>
    </article>
  );
}
